import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

const CountdownDuration = ({ createdAt, minutes }) => {
  const [timeLeft, setTimeLeft] = useState("");
  const [expired, setExpired] = useState(false); // ✅ Track expiry

  useEffect(() => {
    const endTime = dayjs(createdAt).add(minutes, "minute");

    const update = () => {
      const now = dayjs();
      const diff = endTime.diff(now);

      if (diff <= 0) {
        setExpired(true);
        setTimeLeft("Expired duration");
      } else {
        const dur = dayjs.duration(diff);
        const d = dur.days();
        const h = dur.hours();
        const m = dur.minutes();
        setExpired(false);
        setTimeLeft(`${d}d ${h}h ${m}m`);
      }
    };

    update(); // Initial call
    const interval = setInterval(update, 60000); // Every minute
    return () => clearInterval(interval);
  }, [createdAt, minutes]);

  return <span style={{ color: expired ? "red" : "inherit" }}>{timeLeft}</span>;
};

export default CountdownDuration;
